import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { Grid } from "@mui/system";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useLocalStorageState } from "hooks/useLocalStorageState";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";

import { CorrectionComplianceTile } from "./CorrectionComplianceTile";
import { VendorBreakdownTile } from "./VendorBreakdownTile";
import { VENDOR_DASHBOARD_STORAGE_KEY } from "./VendorDashboardToggle";

interface Props {
  shippedDateYear: number;
}

export function VendorDashboard({ shippedDateYear }: Props) {
  const { isStaff } = useCurrentUser();
  const { featureFlags } = useFeatureFlags();
  const enabled = isStaff && featureFlags[FeatureFlagKey.WasteEpaCorrectionDiscrepancies];
  const backgroundColor = useThemeGreyBackgroundColor();

  const [open] = useLocalStorageState<boolean>(VENDOR_DASHBOARD_STORAGE_KEY, {
    defaultValue: true,
  });

  if (!enabled) {
    return null;
  }

  return (
    <Collapse in={open}>
      <Box sx={{ background: backgroundColor, paddingX: 3, paddingY: 2 }}>
        <Grid container spacing={3}>
          <CorrectionComplianceTile shippedYear={shippedDateYear} skip={!open} />
          <VendorBreakdownTile shippedYear={shippedDateYear} skip={!open} />
        </Grid>
      </Box>
    </Collapse>
  );
}
